module.exports = __webpack_public_path__ + "img/fulllogo.3e07e9f4.png";